import { useCallback, useState } from 'react'

import { MoreVerticalIcon } from 'lucide-react'
import { Button, DefaultPopover, Separator, cn } from 'twyne-new.ui'

import { useCustomReportStore } from '../store'

import { CHART_POPOVER_CONTENT_CLASS } from './AddChartPopover'
import ChartForm, { isChartFormValid } from './ChartForm'

export default function ChartSettingsPopover({ chart }) {
  const {
    config: { value: config },
    charts: { update, remove },
  } = useCustomReportStore()

  const [open, setOpen] = useState(false)
  const [form, setForm] = useState(() => ({ ...chart }))

  const handleOpenChange = useCallback(nextOpen => {
    if (nextOpen) setForm({ ...chart })
    setOpen(nextOpen)
  }, [chart])

  const handleSave = useCallback(() => {
    if (!isChartFormValid(form)) return

    update(chart.id, { ...form, name: (form.name || '').trim() })
    setOpen(false)
  }, [chart.id, form, update])

  const handleDelete = useCallback(() => {
    setOpen(false)
    remove(chart.id)
  }, [chart.id, remove])

  return (
    <DefaultPopover
      title="Chart settings"
      wrapperProps={{ open, onOpenChange: handleOpenChange }}
      triggerProps={{ asChild: true }}
      contentProps={{
        className: cn(CHART_POPOVER_CONTENT_CLASS),
        align: 'end',
      }}
      trigger={
        <Button size="sm" variant="ghost" aria-label="Chart settings">
          <MoreVerticalIcon size={16} />
        </Button>
      }
    >
      <div className="flex flex-col gap-4 min-w-0">
        <ChartForm config={config} form={form} setForm={setForm} />
        <Separator className="my-0" />
        <div className="flex items-center justify-between gap-2">
          <Button size="sm" variant="ghost" color="danger" onClick={handleDelete}>
            Delete chart
          </Button>
          <div className="flex gap-2">
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              size="sm"
              color="accent"
              disabled={!isChartFormValid(form)}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </DefaultPopover>
  )
}
